import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const supportedLanguages: string[] = ['es-ES', 'es-MX', 'pt-BR', 'es-PE'];

/**
 * This service will be created per module to manage the module's TranslateService
 */
@Injectable({
  providedIn: 'any'
})
export class LanguageService {
  get onLangChange() {
    return this.translateService.onLangChange;
  }

  get onTranslationChange() {
    return this.translateService.onTranslationChange;
  }

  get currentLang() {
    return this.translateService.currentLang;
  }

  constructor(private translateService: TranslateService) {
    this.initializeTranslateService();
  }

  initializeTranslateService() {
    this.updateLanguage();
    window.addEventListener('languagechange', this.updateLanguage);
  }

  public get(key: string | string[], interpolateParams?: object) {
    return this.translateService?.get(key, interpolateParams);
  }

  public stream(key: string | string[], interpolateParams?: object) {
    return this.translateService?.stream(key, interpolateParams);
  }

  public instant(key: string | string[], interpolateParams?: object) {
    return this.translateService?.instant(key, interpolateParams);
  }

  private updateLanguage = () => {
    this.translateService.currentLang = '';
    this.translateService.use(
      supportedLanguages.some(l => l === navigator.language) ? navigator.language : this.translateService.defaultLang
    );
  };
}
